import type { FormErrors } from '@customTypes/errors';
import api from '@services/api';
import { useState } from 'react';
import { toast } from 'react-toastify';

const useForm = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<FormErrors | null>(null);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const data = Object.fromEntries(formData.entries());

    setLoading(true);

    try {
      const response = await api.post('/account/new-password', {
        email: data.email,
      });

      if (response.data.errors) {
        setErrors(response.data.errors);
      } else {
        setShowConfirmationDialog(true);
      }
    } catch {
      toast.error('Erro ao redefinir a senha. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return {
    onSubmit,
    loading,
    errors,
    showConfirmationDialog,
  };
};

export default useForm;
